import {
    ServiceProcessFieldTableColumnOptions,
    ServiceProcessFieldTableColumnVM,
} from '@shared/types/process';

export function normalizeColumnOptions(
    options: ServiceProcessFieldTableColumnVM['options'] | string,
): ServiceProcessFieldTableColumnOptions | null {
    if (options == null || options === '') {
        return null;
    }

    if (typeof options === 'string') {
        try {
            return JSON.parse(
                options,
            ) as ServiceProcessFieldTableColumnOptions;
        } catch {
            return null;
        }
    }

    return options;
}
